// API Configuration
const API_CONFIG = {
  BASE_URL: 'https://nisa-care.com/backend',
  
  ENDPOINTS: {
    NEWSLETTER: '/newsletter.php',
    INTEREST: '/interest.php',
    CONTACT: '/contact.php',
    AUTH: '/auth.php',
    GET_DATA: '/get-data.php',
    DOWNLOAD: '/download.php',
    CHANGE_PASSWORD: '/change-password.php'
  }
};

// Helper function to get full URL
export const getApiUrl = (endpoint) => {
  return `${API_CONFIG.BASE_URL}${API_CONFIG.ENDPOINTS[endpoint]}`;
};

export default API_CONFIG;